import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============= PRODUCTION CONSOLE SILENCING =============
// En production, on désactive console.log / warn / info / debug pour :
//   - Ne pas exposer d'infos internes (URLs API, structures de données, etc.)
//   - Réduire l'empreinte mémoire et l'impact perf sur les anciens téléphones
//   - Garder un environnement console propre côté utilisateur
// console.error est conservé pour capturer les erreurs critiques.
// Override : ?debug=true dans l'URL force la réactivation pour le support.
if (process.env.NODE_ENV === 'production') {
  const params = new URLSearchParams(window.location.search);
  const debugMode = params.get('debug') === 'true' || window.localStorage.getItem('gl_debug') === '1';
  if (!debugMode) {
    const noop = () => {};
    /* eslint-disable no-console */
    console.log = noop;
    console.warn = noop;
    console.info = noop;
    console.debug = noop;
    /* eslint-enable no-console */
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker Registration for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {

        // Écouter les messages du SW pour Background Sync
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'SYNC_AVAILABLE') {
            window.dispatchEvent(new CustomEvent('sw-sync-available'));
          }
        });
      })
      .catch(() => {});
  });
}
